import React from 'react';
import { useNavigate } from 'react-router-dom';
import { urls } from '..';
import { removeMultipleSlashes } from '../data/sport-utils';
import { getLabel } from '../data/labels';

export default function LiveStreamingDropdownButton() {
    const navigate = useNavigate();

    return (
        <div className="shrink-0 h-[50px] grid grid-cols-12 items-center border-y border-y-cs7 streaming-button" onClick={() => navigate(removeMultipleSlashes(`${urls.base}/${urls.live.base}/agenda`))}>
            <div className={"col-start-1 col-end-3 justify-self-center inline-flex items-center justify-center w-[24px] h-[24px]"}>
                <img height="24px" width="24px" src={`${process.env.PUBLIC_URL}/assets/images/live-streaming.svg`} alt="Live streaming button" />
            </div>
            <div className="col-start-3 col-end-13 font-medium text-sm text-cs-3">{getLabel('live.live_feed')}</div>
        </div>
    );
}
